import * as React from 'react';
import { memo } from 'react';

import { isString } from '@impuls-coach/util-is';

import { getCachedPath } from 'helper/cache';
import appConfig from 'helper/mapBackendConfig';

export type UIAssetProps = {
	src: string;
	alt?: string;
	className?: string;
};

export const getUIAssetPath = (src: string): string => {
	if (src.charAt(0) === '/') {
		src = src.substring(1);
	}
	return `${appConfig.env.baseUrlUi}/assets/${getCachedPath(src)}`;
};

export const UIAsset = ({ src, className, alt = '' }: UIAssetProps) => {
	if (!isString(src)) {
		return null;
	}

	return <img className={className} src={getUIAssetPath(src)} alt={alt} />;
};

UIAsset.displayName = 'UIAsset';

export default memo(UIAsset, (prevProps, nextProps) => {
	return prevProps.src === nextProps.src && prevProps.className === nextProps.className;
});
